import React from "react";
import css from "./HomePage.module.css";
import Main from "../../components/Main/Main";

const HomePage = () => {
  return (
    <div className={css.container}>
      <Main />
    </div>
  );
};

export default HomePage;
